<script>
    import main from '../../state/main';
    import user from '../../state/user';
    import modals from '../../state/modals';

    export let page = null;

    let isMenuOpen = false;

    function toggleMenu(e) {
        e.preventDefault();
        isMenuOpen = !isMenuOpen;
    }

    function getBaseWeb() {
        const host = location.host;
        const proto = location.protocol;
        const baseHost = host.replace(/^[^.]+/, '');

        return `${proto}//` + (/^rezervace\./.exec(host) ? 'www' : 'test') + baseHost;
    }

    function onLoginClick() {
        modals.toggleSignModal(true);
    }

    function onCreditsClick() {
        modals.toggleCreditsModal(true);
    }

    function onProfileClick() {
        modals.toggleProfileModal(true);
    }

    function onLogoutClick() {
        user.signOut();
    }
</script>

<style>
    .navbar {
        box-shadow: 0 0 8px rgba(0, 0, 0, 0.25);
    }

    .navbar-brand img {
        margin-right: 10px;
    }

    .user {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        height: 36px;
        margin-right: 20px;
    }

    .user .user-name {
        display: block;
        line-height: 22px;
    }

    .user .user-credits {
        display: block;
        line-height: 14px;
        font-size: 75%;
        text-align: right;
    }

    ._vertical-middle {
        display: flex;
        align-items: center;
    }

    @media screen and (max-width: 1023px) {
        ._vertical-middle {
            flex-direction: column;
            align-items: flex-start;
        }

        .user {
            margin-right: 0;
            margin-bottom: 20px;
        }
    }
</style>

<nav class="navbar" role="navigation" aria-label="Navigace">
    <div class="navbar-brand">
        <a class="navbar-item" href="/" aria-label="Rezervace">
            <img src="/favicon/favicon.svg" height="28" alt="ChytryPohyb.cz">
            Rezervace
        </a>

        <a
            href="#toggle"
            role="button"
            class="navbar-burger burger"
            aria-label="Menu"
            aria-expanded="false"
            on:click={toggleMenu}
            class:is-active={isMenuOpen}>
            <span aria-hidden="true" />
            <span aria-hidden="true" />
            <span aria-hidden="true" />
        </a>
    </div>

    <div class="navbar-menu" class:is-active={isMenuOpen}>
        <div class="navbar-start">
            <a class="navbar-item" href={$main.baseWeb}>Zpět na stránky</a>

            {#if $main.archiveEnabled}
                {#if page === 'home'}
                    <a class="navbar-item" href="/archiv">Archiv lekcí</a>
                {:else if page === 'archive'}
                    <a class="navbar-item" href="/">Plán lekcí</a>
                {/if}
            {/if}
        </div>

        <div class="navbar-end">
            {#if $user}
                <div class="navbar-item _vertical-middle">
                    <span class="user">
                        <b class="user-name">{$user.cln_name}</b>
                        <em class="user-credits">Kredity: <b class="user-credits-amount">{$user.credits}</b></em>
                    </span>

                    <div class="buttons">
                        <button class="button is-primary" on:click={onProfileClick}>Profil</button>
                        <button class="button is-primary" on:click={onCreditsClick}>Dobít kredity</button>
                        <button class="button is-primary" on:click={onLogoutClick}>Odhlásit se</button>
                    </div>
                </div>
            {:else}
                <div class="navbar-item">
                    <span class="user">Nepřihlášen</span>
                    <button class="button is-primary" on:click={onLoginClick}>Přihlásit se / registrovat</button>
                </div>
            {/if}
        </div>
    </div>
</nav>
